<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb47></breadcrumb47>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar2></sidebar2>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                  <div class="row ml-md-2" style="margin-top: -25px;">
                    <div class="col-md-12" id="patient_container">
                      <!-- <h3 class="mb-3">Patient Appointments on {{ currentDay }}, {{ todays_date }}</h3> -->
                      <!-- <h4 class="mb-4">Patient Appoinment</h4> -->
                      <div class="appointment-tab">
                        <!-- Appointment Tab -->
                        <ul class="nav nav-tabs nav-tabs-solid nav-tabs-rounded">
                          <li class="nav-item mr-1 mt-1 mb-1">
                            <!-- <p class="text-center">{{todays_appointment}}</p> -->
                            <a class="nav-link active" href="#today-appointments" data-toggle="tab">Today <span
                                class="rounded-brackets">{{ todays_appointment }}</span></a>
                          </li>
                          <li class="nav-item mr-1 mt-1">
                            <!-- <p class="text-center">{{ total_appointment }}</p> -->
                            <a class="nav-link" href="#upcoming-appointments" data-toggle="tab">
                              Upcoming <span class="rounded-brackets">{{ total_appointment }}</span>
                            </a>
                          </li>
                          <li class="nav-item mr-1 mt-1">
                            <!-- <p class="text-center">{{count_closed}}</p>  -->
                            <a class="nav-link" href="#closed-appointments" data-toggle="tab">Closed <span
                                class="rounded-brackets">{{ count_closed }}</span></a>
                          </li>
                          <li class="nav-item mr-1 mt-1">
                            <!-- <p class="text-center">{{cancel_appointment}}</p> -->
                            <a class="nav-link" href="#cancel-appointments" data-toggle="tab">Cancelled <span
                                class="rounded-brackets">{{ cancel_appointment }}</span></a>
                          </li>

                        </ul>
                        <!-- /Appointment Tab -->

                        <div class="tab-content">
                          <!-- Upcoming Appointment Tab -->
                          <div class="tab-pane" id="upcoming-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <thead>
                                      <tr>
                                        <th style="background-color: #F8F8F8; width:200px;" class="text-left">Patient Name
                                        </th>
                                        <th style="background-color: #F8F8F8;" class="text-left">City</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Doctor</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Appt Date</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Slot</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item,
                                        $index) in upcoming_appointments" :key="item.id"
                                        v-show="setUpcomingPaginate($index)">
                                        <td class="text-left">
                                          <h2 class="table-avatar">
                                            <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img class="
                                                  avatar-img
                                                  rounded-circle
                                                " v-bind:src="item.image
                                                  ? config.base_url_for_Image +
                                                  item.image
                                                  : loadImg(
                                                    'Patient Profile.svg'
                                                  )
                                                  " alt="User Image" /></a>
                                            <a href="javascript:void(0);">{{ item.patient_name
                                            }}<span>{{ item.mobile }}</span></a>
                                          </h2>
                                        </td>

                                        <td class="text-left">{{ item.city }}</td>
                                        <td class="text-left">{{ item.practitioner_name }}</td>
                                        <td class="text-left">
                                          {{
                                            convertDate(
                                              item.appointment_datetime
                                            )
                                          }}
                                          <span class="d-block text-info">{{
                                            convertTime(
                                              item.appointment_datetime
                                            )
                                          }}</span>
                                        </td>
                                        <td class="text-left">{{ item.custom_slot_no }}</td>

                                        <td class="text-left">{{ item.status }}</td>
                                        <td class="text-left">
                                          <div class="table-action">
                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#viewappointment" @click="
                                                viewappointmentdata(
                                                  item.name,
                                                  false
                                                )
                                                " class="btn btn-sm bg-info-light">
                                              <i class="far fa-eye"></i> View
                                            </a>

                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#rescheduleappointment" class="
                                                btn btn-sm
                                                bg-success-light
                                              " @click="reschedule(item)">
                                              <i class="fas fa-check"></i>
                                              Reschedule
                                            </a>
                                            <a @click="
                                              cancel_appointments(item.name, item.patient_name)
                                              " href="javascript:void(0);" class="btn btn-sm bg-danger-light">
                                              <i class="fas fa-times"></i>
                                              Cancel
                                            </a>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 v-if="upcoming_appointments.length === 0" class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                                <!-- pagination start -->
                                <div id="pagination" v-if="upcoming_appointments.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="upcoming_current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateUpcomingCurrent(upcoming_current - 1)">
                                        Previous
                                      </a>
                                    </li>

                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in upcoming_paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      upcoming_current === page_index ? 'active' : ''
                                    ]" v-if="page_index >= upcoming_current - 2 && page_index <= upcoming_current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateUpcomingCurrent(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="upcoming_current === upcoming_paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateUpcomingCurrent(upcoming_current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                          </div>
                          <!-- /Upcoming Appointment Tab -->

                          <!-- Today Appointment Tab -->
                          <div class="tab-pane show active" id="today-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <thead>
                                      <tr>
                                        <th style="background-color: #F8F8F8;" class="text-left">Patient Name</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">City</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Doctor</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Slot</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Encounter Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item,
                                        $index) in todays_appointments" :key="item.id"
                                        v-show="setTodayPaginate($index)">
                                        <td class="text-left">
                                          <h2 class="table-avatar">
                                            <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img class="
                                                  avatar-img
                                                  rounded-circle
                                                " v-bind:src="item.image
                                                  ? config.base_url_for_Image +
                                                  item.image
                                                  : loadImg(
                                                    'Patient Profile.svg'
                                                  )
                                                  " alt="User Image" /></a>
                                            <a href="javascript:void(0);">{{ item.patient_name
                                            }}<span>{{ item.mobile }}</span></a>
                                          </h2>
                                        </td>
                                        <td class="text-left">{{ item.city }}</td>
                                        <td class="text-left">{{ item.practitioner_name }}</td>
                                        <td class="text-left">{{ item.custom_slot_no }}</td>
                                        <td class="text-left">{{ item.status }}</td>
                                        <td class="text-left">
                                          {{ item.patient_encounter_status }}
                                        </td>
                                        <td class="text-left">
                                          <div class="table-action">
                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#viewappointment" @click="
                                                viewappointmentdata(
                                                  item.name,
                                                  false
                                                )
                                                " class="btn btn-sm bg-success-light">
                                              <i class="far fa-eye"></i> View
                                            </a>

                                            <a href="javascript:void(0);" class="btn btn-sm bg-info-light" @click="
                                              add_patient_encounter_new(
                                                item.patient,
                                                item.name,
                                                item.patient_encounter,
                                                item.patient_encounter_status
                                              )
                                              " v-if="item.status !== 'Cancelled' && item.status !== 'Closed'">
                                              <i class="far fa-eye"></i>
                                              View Encounter
                                              <!-- </router-link> -->
                                            </a>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 v-if="todays_appointments.length === 0" class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                                <!-- pagination start -->
                                <div id="pagination" v-if="todays_appointments.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="today_current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateTodayCurrent(today_current - 1)">
                                        Previous
                                      </a>
                                    </li>
                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in today_paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      today_current === page_index ? 'active' : ''
                                    ]" v-if="page_index >= today_current - 2 && page_index <= today_current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateTodayCurrent(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="today_current === today_paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateTodayCurrent(today_current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                          </div>
                          <!-- /Today Appointment Tab -->

                          <!-- Closed Appointment Tab -->
                          <div class="tab-pane" id="closed-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <thead>
                                      <tr>
                                        <th style="background-color: #F8F8F8;" class="text-left">Patient Name</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">City</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Doctor</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Date</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Slot</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Encounter Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item,
                                        $index) in closed_appointments" :key="item.id"
                                        v-show="setClosedPaginate($index)">
                                        <td class="text-left">
                                          <h2 class="table-avatar">
                                            <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img class="
                                                  avatar-img
                                                  rounded-circle
                                                " v-bind:src="item.image
                                                  ? config.base_url_for_Image +
                                                  item.image
                                                  : loadImg(
                                                    'Patient Profile.svg'
                                                  )
                                                  " alt="User Image" /></a>
                                            <a href="javascript:void(0);">{{ item.patient_name
                                            }}<span>{{ item.mobile }}</span></a>
                                          </h2>
                                        </td>
                                        <td class="text-left">{{ item.city }}</td>
                                        <td class="text-left">{{ item.practitioner_name }}</td>
                                        <td class="text-left">
                                          {{
                                            convertDate(
                                              item.appointment_datetime
                                            )
                                          }}<span class="d-block text-info">{{ convertTime(item.appointment_datetime)
}}</span>
                                        </td>
                                        <td class="text-left">{{ item.custom_slot_no }}</td>

                                        <td class="text-left">{{ item.status }}</td>
                                        <td class="text-left">
                                          {{ item.patient_encounter_status }}
                                        </td>
                                        <td class="text-left">
                                          <div class="table-action">
                                            <a href="javascript:void(0);" class="btn btn-sm bg-info-light"
                                              @click="ClosedAppointment()">
                                              <router-link :to="{
                                                name:
                                                  'update-patient-encounter',
                                                params: {
                                                  patient_id: item.patient,
                                                  appointment_id: item.name,
                                                  encounter_id:
                                                    item.patient_encounter,
                                                },
                                              }">
                                                <i class="far fa-eye"></i>
                                                View Encounter
                                              </router-link>
                                            </a>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 v-if="closed_appointments.length === 0" class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                                <!-- pagination start -->
                                <div id="pagination" v-if="closed_appointments.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="closed_current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateClosedCurrent(closed_current - 1)">
                                        Previous
                                      </a>
                                    </li>

                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in closed_paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      closed_current === page_index ? 'active' : ''
                                    ]" v-if="page_index >= closed_current - 2 && page_index <= closed_current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateClosedCurrent(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="closed_current === closed_paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateClosedCurrent(closed_current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                          </div>
                          <!-- /Closed Appointment Tab -->

                          <!-- Cancel Appointment Tab -->
                          <div class="tab-pane" id="cancel-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <thead>
                                      <tr>
                                        <th style="background-color: #F8F8F8; width:200px;" class="text-left">Patient Name
                                        </th>
                                        <th style="background-color: #F8F8F8;" class="text-left">City</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Doctor</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Appt Date</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item,
                                        $index) in cancelled_appointment" :key="item.id"
                                        v-show="setCancelledPaginate($index)">
                                        <td class="text-left">
                                          <h2 class="table-avatar">
                                            <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img class="
                                                  avatar-img
                                                  rounded-circle
                                                " v-bind:src="item.image
                                                  ? config.base_url_for_Image +
                                                  item.image
                                                  : loadImg(
                                                    'Patient Profile.svg'
                                                  )
                                                  " alt="User Image" /></a>
                                            <a href="javascript:void(0);">{{ item.patient_name
                                            }}<span>{{ item.mobile }}</span></a>
                                          </h2>
                                        </td>
                                        <td class="text-left">{{ item.city }}</td>
                                        <td class="text-left">{{ item.practitioner_name }}</td>
                                        <td class="text-left">
                                          {{
                                            convertDate(
                                              item.appointment_datetime
                                            )
                                          }}<span class="d-block text-info">{{ convertTime(item.appointment_datetime)
}}</span>
                                        </td>

                                        <td class="text-left">{{ item.status }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 v-if="cancelled_appointment.length === 0" class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                                <!-- pagination start -->
                                <div id="pagination" v-if="cancelled_appointment.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="cancelled_current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateCancelledCurrent(cancelled_current - 1)">
                                        Previous
                                      </a>
                                    </li>

                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in cancelled_paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      cancelled_current === page_index ? 'active' : ''
                                    ]"
                                      v-if="page_index >= cancelled_current - 2 && page_index <= cancelled_current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateCancelledCurrent(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="cancelled_current === cancelled_paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateCancelledCurrent(cancelled_current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                          </div>
                          <!-- /Cancel Appointment Tab -->

                          <!-- All Appointment Tab -->
                          <div class="tab-pane" id="all-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <tbody>
                                      <div class="
                                          appointments
                                          doctor-appointments-scrollbar
                                        " v-if="appointments.length">
                                        <div class="appointment-list" v-for="item in appointments" :key="item.id">
                                          <div class="profile-info-widget">
                                            <a href="javascript:void(0);" class="booking-doc-img">
                                              <div></div>
                                              <img v-bind:src="item.image
                                                ? config.base_url_for_Image +
                                                item.image
                                                : loadImg(
                                                  'Patient Profile.svg'
                                                )
                                                " alt="User Image" />
                                            </a>
                                            <div class="profile-det-info">
                                              <h3>
                                                <a href="javascript:void(0);">
                                                  {{ item.patient_name }}
                                                </a>
                                              </h3>
                                              <div class="patient-details">
                                                <h5>
                                                  <i class="far fa-clock"></i>{{
                                                    convertDate(
                                                      item.appointment_datetime
                                                    )
                                                  }}
                                                  ,
                                                  <span class="text-info">{{
                                                    convertTime(
                                                      item.appointment_datetime
                                                    )
                                                  }}</span>
                                                </h5>
                                                <h5>
                                                  <i class="
                                                      fas
                                                      fa-map-marker-alt
                                                    "></i>
                                                  {{
                                                    item.city ? item.city : "-"
                                                  }}
                                                </h5>
                                                <h5 class="mb-0">
                                                  <i class="fas fa-phone"></i>
                                                  {{
                                                    item.mobile
                                                    ? item.mobile
                                                    : "-"
                                                  }}
                                                </h5>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="appointment-action">
                                            <a href="#" class="btn btn-sm bg-info-light" data-toggle="modal"
                                              data-target="#appt_details">
                                              <router-link :to="{
                                                    name: 'new-patient-encounter',
                                                    params: {
                                                      patient_id: item.patient,
                                                      appointment_id: item.name,
                                                    },
                                                  }">
                                                <i class="far fa-eye"></i>
                                                View Encounter
                                              </router-link>
                                            </a>
                                            <a href="#" class="btn btn-sm bg-info-light" data-toggle="modal"
                                              data-target="#viewappointment" @click="
                                                viewappointmentdata(
                                                  item.name,
                                                  false
                                                )
                                                ">
                                              <i class="far fa-eye"></i> View
                                            </a>
                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#rescheduleappointment" class="
                                                btn btn-sm
                                                bg-success-light
                                              " @click="reschedule(item)">
                                              <i class="fas fa-check"></i>
                                              Reschedule
                                            </a>
                                            <a @click="
                                              cancel_appointments(item.name, item.patient_name)
                                              " class="btn btn-sm bg-danger-light">
                                              <i class="fas fa-times"></i>
                                              Cancel
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </tbody>
                                  </table>
                                  <h5 v-if="appointments.length === 0 && !showspinner
                                    " class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- /All Appointment Tab -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
      <div class="modal fade custom-modal show" id="viewappointment">
        <div class="modal-dialog modal-dialog-centered modal-md appointment_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12 text-center">
                      <div class="form-group">
                        <img src="@/assets/img/logo/helthcare_logo.jpeg" alt="logo" class="appointment_modal_logo"
                          style="width: 120px; height: 37px;" />
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="widget-profile appointment-modal-no-border">
                        <div class="profile-info-widget">
                          <a class="booking-doc-img">
                            <img v-bind:src="appointments_details.image
                              ? config.base_url_for_Image +
                              appointments_details.image
                              : loadImg('Patient Profile.svg')
                              " alt="User Image" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal">
                        <h5>{{ appointments_details.patient_name }}</h5>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal">
                        <h5>{{ appointments_details.mobile }}</h5>
                      </div>
                    </div>
                    <div class="text-center ml-5">
                    <div class="col-12 col-md-12 mt-4">
                      <div class="appointment-modal text-left">
                        <b style="color:black;" class="ml-1">Appointment Details</b>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 mt-4">
                      <div class="appointment-modal text-left">
                        <label class="ml-1">Date :</label>
                        <label>{{
                          appointments_details.appointment_date
                        }}</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal text-left">
                        <label class="ml-1">Time :</label>
                        <label>{{
                          appointments_details.appointment_time
                        }}</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal text-left">
                        <label class="ml-1">Hospital :</label>
                        <label>{{ appointments_details.hospital }}</label>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div class="text-center mt-4">
                    <a href="javascript:void(0);" class="btn btn-sm bg-primary-light" @click="
                      viewappointmentdata(appointments_details.name, true)
                      ">
                      <i class="fas fa-print"></i> Print
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade custom-modal show" id="viewappointment1">
        <div class="modal-dialog modal-dialog-centered modal-md appointment_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
              :paginate-elements-by-height="1400" filename="appointment" :pdf-quality="2" :manual-pagination="false"
              pdf-format="a4" pdf-orientation="portrait" pdf-content-width="400px" @hasDownloaded="hasGenerated($event)"
              ref="html2Pdf">
              <section slot="pdf-content">
                <div class="modal-body">
                  <div class="card">
                    <div class="card-body">
                      <div class="row form-row">
                        <div class="col-12 col-md-12 text-center">
                          <div class="form-group">
                            <img src="@/assets/img/logo/helthcare_logo.jpeg" alt="logo" class="appointment_modal_logo"
                              style="width: 120px; height: 37px;" />
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="widget-profile appointment-modal-no-border">
                            <div class="profile-info-widget">
                              <a class="booking-doc-img">
                                <img v-bind:src="appointments_details.image
                                  ? config.base_url_for_Image +
                                  appointments_details.image
                                  : loadImg('Patient Profile.svg')
                                  " alt="User Image" />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal">
                            <h5>{{ appointments_details.patient_name }}</h5>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal">
                            <h5>{{ appointments_details.mobile }}</h5>
                          </div>
                        </div>
                        <div class="text-center ml-5">
                        <div class="col-12 col-md-12 mt-4">
                          <div class="appointment-modal text-left">
                            <b style="color:black;" class="ml-1">Appointment Details</b>
                          </div>
                        </div>
                        <div class="col-12 col-md-12 mt-4">
                          <div class="appointment-modal text-left">
                            <label class="ml-1">Date :</label>
                            <label>{{
                              appointments_details.appointment_date
                            }}</label>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal text-left">
                            <label class="ml-1">Time :</label>
                            <label>{{
                              appointments_details.appointment_time
                            }}</label>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal text-left">
                            <label class="ml-1">Hospital :</label>
                            <label>{{
                              appointments_details.hospital
                            }}</label>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </vue-html2pdf>
          </div>
        </div>
      </div>

      <div class="modal fade custom-modal show" id="rescheduleappointment">
        <div class="modal-dialog modal-dialog-centered modal-md reschedule_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Reschedule Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <h4 v-if="selected_object != undefined" class="mb-1" id="alternate_date">
                          {{ get_moment(selected_object).format("D MMMM YYYY") }}
                        </h4>
                        <p v-if="selected_object != undefined" class="text-muted">
                          {{ get_moment(selected_object).format("dddd") }}
                        </p>
                        <h4 v-if="selected_object == undefined">Select Booking Date</h4>
                      </div>
                      <div class="col-12 col-sm-4 col-md-6 text-sm-right">
                        <div class="bookingrange btn btn-white btn-sm mb-3">
                          <VueDatePicker v-model="selected_date" placeholder="Choose date" color="#15558d"
                            :minDate="disabledDates" @onChange="get_slots" />
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <div class="card booking-schedule schedule-widget" v-if="selected_object != undefined">
                          <!-- Schedule Header -->
                          <div class="schedule-header">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="day-slot" v-if="next_days.length > 0">
                                  <ul v-if="selected_object != undefined">
                                    <li v-for="(day, index) in next_days" :key="index" @click="change_date(day)">
                                      <div :class="{
  'font-weight-bold': get_moment(day).format('MMM Do YY') === get_moment(selected_object).format('MMM Do YY'),
  'reshedule_active_item': day === selected_object,
  'green-text': get_moment(day).format('ddd') === selected_day, 
}">
                                          <span style="font-size:15px;">{{ get_moment(day).format("ddd") }}</span>
                                        <span class="slot-date" style="font-size:13px;">{{ get_moment(day).format("D MMM YY") }}</span>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                <!-- /Day Slot -->
                              </div>
                            </div>
                          </div>
                          <!-- /Schedule Header -->
                          <div class="schedule-cont" v-if="slots != undefined">
                            <div class="row">
                              <div class="col-md-12">
                                <!-- Time Slot -->
                                <div class="time-slot">
                                  <ul>
                                    <li>Slot Number and Estimated Time</li>
                                  </ul>
                                  <ul class="clearfix">
                                    <li v-for="(slot, index) in slots" :key="index">
                                      <a :id="slot.name" class="timing" :class="active_slot === index ? 'active' : ''"
                                        @click="set_slot(slot, index)" :disabled="slot.booked">
                                        <span class="slot_number">{{ slot.slot_no }}</span>
                                        <br />
                                        <span>{{ slot.from_time.slice(0, 5) }}</span>

                                        <!-- Add this line to display the slot number -->
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- /Time Slot -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="text-center mt-4">
                        <div class="submit-section text-left"
                          v-if="selected_object != undefined && selected_slot != undefined">
                          <button type="submit" id="medical_btn" class="btn btn-primary submit-btn" data-dismiss="modal"
                            aria-label="Close" :disabled="disabled" @click="Reschedule_appointments()">
                            Reschedule
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.aligninput {
  margin: 0 1rem 0 0;
}

.custom_class {
  max-width: 170px;
  text-align: left;
  width: 100%;
  float: right;
}

.timing {
  cursor: pointer;
}

.day-slot ul li {
  cursor: pointer;
}

.container.booking {
  min-height: 50vh;
}

a[disabled="disabled"] {
  pointer-events: none;
  cursor: default;
}
</style>

<script>
import CommonApi from "@/services/CommonApi";
import { mapState } from "vuex";
import config from "../../../services/CommonApi";
const images = require.context("@/assets/img/patients");
import { VueDatePicker } from "@mathieustan/vue-datepicker";
const doctorimages = require.context("@/assets/img/doctors");
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import VueHtml2pdf from "vue-html2pdf";

export default {
  data() {
    return {
      total_appointment: "",
      todays_appointment: "",
      todays_date: new Date()
        .toString()
        .split(" ")
        .splice(1, 3)
        .join(" "),
      count_closed: "",
      cancel_appointment: "",
      patient_name: "",
      selected_date: undefined,
      disabledDates: new Date(),
      selected_object: undefined,
      next_days: [],
      slot_no: "",
      slots: undefined,
      selected_slot: undefined,
      encounter_modes: [],
      selected_hospital: "",
      active_slot: undefined,

      download: false,
      fake_appointments_details: {},
      format: "dd-MM-yyyy",
      appointments: [],
      showspinner: true,
      config: config,
      disabled: true,

      upcoming_appointments: [],
      todays_appointments: [],
      closed_appointments: [],
      cancelled_appointment: [],

      reschedule_appointment: {
        hospital: "",
        appointment_type: "",
        patient: "",
        practitioner: this.$store.state.user.user_id,
        service_unit: "",
        appointment_id: "",
        appointment_date: "",
        appointment_time: "",
      },

      appointments_details: {
        patient_name: "",
        mobile: "",
        appointment_date: "",
        appointment_time: "",
        hospital: "",
        image: "",
      },

      //pagination
      upcoming_current: 1,
      upcoming_paginate: 10,
      upcoming_paginate_total: 0,

      today_current: 1,
      today_paginate: 10,
      today_paginate_total: 0,

      closed_current: 1,
      closed_paginate: 10,
      closed_paginate_total: 0,

      cancelled_current: 1,
      cancelled_paginate: 10,
      cancelled_paginate_total: 0,

      doctor_name:"",
    };

  },
  components: { VueDatePicker, VueHtml2pdf },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    $("#booking-from").datetimepicker({
      format: "DD/MM/YYYY",
      icons: {
        up: "fas fa-chevron-up",
        down: "fas fa-chevron-down",
        next: "fas fa-chevron-right",
        previous: "fas fa-chevron-left",
      },
    });
    // this.get_patient_appointment_list_all();
    this.get_patient_appointment_upcoming(),
      this.get_patient_appointment_list_today(),
      this.get_patient_appointment_list_closed();
    this.get_patient_appointment_list_canceled();
    this.get_patient_appointment_count_upcoming();
    this.get_patient_appointment_count_today();
    this.get_patient_encounter_count_closed();
    this.get_patient_appointment_count_cancel();
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      closedAppointment: (state) => state.user.closedAppointment,

    }),

    currentDay() {
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const today = new Date().getDay(); // Get the current day of the week (0-6)

      return daysOfWeek[today];
    },
    reschedule_validation() {
      return (
        this.reschedule_appointment.appointment_date &&
        this.reschedule_appointment.appointment_time
      );
    },
  },
  watch: {
    reschedule_validation() {
      if (
        this.reschedule_appointment.appointment_date === "" ||
        this.reschedule_appointment.appointment_time === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    fake_appointments_details: {
      handler() {
        if (this.download) {
          setTimeout(this.generateReport(), 2000);
        }
      },
      deep: true,
    },
  },
  methods: {

    closeModal() {
      location.reload();
    },

    get_patient_appointment_count_upcoming() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data(
        "sahaj.hospital.get_hospital_appointments_count_upcoming",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.total_appointment = res.data;
        }
      });
    },

    get_patient_appointment_count_today() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data(
        "sahaj.hospital.get_hospital_appointments_count_today",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.todays_appointment = res.data;
        }
      });
    },

    get_patient_encounter_count_closed() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data(
        "sahaj.hospital.get_hospital_appointments_count_closed",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.count_closed = res.data;
        }
      });
    },

    get_patient_appointment_count_cancel() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data(
        "sahaj.hospital.get_hospital_appointments_count_cancelled",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.cancel_appointment = res.data;
        }
      });
    },

    async get_slots() {
      this.slots = undefined;
      this.active_slot = undefined;
      this.next_days = [];
      this.selected_day = this.get_moment(this.selected_date).format("ddd");
      this.selected_object = new Date(this.selected_date);
      for (var i = 0; i <= 6; i++) {
        var currentDate = new Date(this.selected_date);
        currentDate.setDate(this.selected_object.getDate() + i);
        this.next_days.push(currentDate);
      }

      let search = new URLSearchParams({
        date: this.selected_date,
        practitioner: this.doctor_name,
      });
      await CommonApi.get_data(
        "sahaj.appointment.get_availability_data",
        search
      ).then((res) => {
        let slots = res.data.slot_details;
        this.slots = slots.find(
          (x) => x.hospital === this.reschedule_appointment.hospital).avail_slot;
      });
    },

    get_moment(obj) {
      return moment(obj);
    },
    set_slot(slot, index) {
      this.selected_slot = slot;
      this.active_slot = index;
      $("a.timing").removeClass("selected");
      $("#" + slot.name).addClass("selected");
    },
    async change_date(day) {
    this.selected_object = day;
    this.selected_day = this.get_moment(day).format("ddd");
    this.active_slot = undefined;

    let search = new URLSearchParams({
      date: this.get_moment(day).format("YYYY-MM-DD"),
      practitioner: this.doctor_name,
    });
    this.selected_date = this.get_moment(day).toDate();
    await CommonApi.get_data(
      "sahaj.appointment.get_availability_data",
      search
    ).then((res) => {
      let slots = res.data.slot_details;
      this.slots = slots.find(
        (x) => x.hospital === this.reschedule_appointment.hospital
      ).avail_slot;
    });
  },

    // pagination
    setUpcomingPaginate(i) {
      if (this.upcoming_current == 1) {
        return i < this.upcoming_paginate;
      } else {
        return (
          i >= this.upcoming_paginate * (this.upcoming_current - 1) &&
          i < this.upcoming_current * this.upcoming_paginate
        );
      }
    },

    updateUpcomingCurrent(i) {
      this.upcoming_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setTodayPaginate(i) {
      if (this.today_current == 1) {
        return i < this.today_paginate;
      } else {
        return (
          i >= this.today_paginate * (this.today_current - 1) &&
          i < this.today_current * this.today_paginate
        );
      }
    },

    updateTodayCurrent(i) {
      this.today_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setClosedPaginate(i) {
      if (this.closed_current == 1) {
        return i < this.closed_paginate;
      } else {
        return (
          i >= this.closed_paginate * (this.closed_current - 1) &&
          i < this.closed_current * this.closed_paginate
        );
      }
    },

    setCancelledPaginate(i) {
      if (this.cancelled_current == 1) {
        return i < this.cancelled_paginate;
      } else {
        return (
          i >= this.cancelled_paginate * (this.cancelled_current - 1) &&
          i < this.cancelled_current * this.cancelled_paginate
        );
      }
    },

    updateClosedCurrent(i) {
      this.closed_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    updateCancelledCurrent(i) {
      this.cancelled_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    // pagination end

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    ClosedAppointment() {
      this.$store.dispatch("user/closedAppointment", true);
    },

    loadDoctorImg(imgPath) {
      return doctorimages("./" + imgPath);
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    hasGenerated(blob) {
      let url = URL.createObjectURL(blob);
      window.open(url); //opens the pdf in a new tab
    },

    /* Add Patient Encouner Data  */
    async add_patient_encounter_new(
      patient_id,
      appointment_id,
      patient_encounter_id,
      patient_encounter_status
    ) {
      if (patient_encounter_id !== null) {
        this.$router.push(
          `/hospital/hospital-update-patient-encounter/${patient_id}/${appointment_id}/${patient_encounter_id}`
        );
      } else {
        var bodyFormData = new FormData();
        let data = {
          appointment: appointment_id,
          patient: patient_id,
          practitioner: this.user_id,
        };
        bodyFormData.append("data", JSON.stringify(data));
        await CommonApi.post_data(
          "sahaj.api.add_patient_encounter_new",
          bodyFormData
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$store.dispatch("user/closedAppointment", false);
            this.$router.push(
              `/hospital/hospital-update-patient-encounter/${patient_id}/${appointment_id}/${res.data}`
            );
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      }
    },

    /* Get Upcoming Appointment Data */
    get_patient_appointment_upcoming() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data(
        "sahaj.hospital.get_hospital_appointments_upcoming",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.doctor_name = res.data[0].practitioner;
          this.upcoming_appointments = res.data;
          this.upcoming_paginate_total = Math.ceil(
            this.upcoming_appointments.length / this.upcoming_paginate
          );
        }
      });
      
    },

    /* Get Today Appointment Data */
    get_patient_appointment_list_today() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data(
        "sahaj.hospital.get_hospital_appointments_today",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.todays_appointments = res.data;
          this.today_paginate_total = Math.ceil(
            this.todays_appointments.length / this.today_paginate
          );
        }
      });
    },

    /* Get Closed Appointment Data */
    get_patient_appointment_list_closed() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data(
        "sahaj.hospital.get_hospital_appointments_closed",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.closed_appointments = res.data;
          this.closed_paginate_total = Math.ceil(
            this.closed_appointments.length / this.closed_paginate
          );
        }
      });
    },

    /* Get Cancel Appointment Data */
    get_patient_appointment_list_canceled() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data(
        "sahaj.hospital.get_hospital_appointments_cancelled",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.cancelled_appointment = res.data;
          this.cancelled_paginate_total = Math.ceil(
            this.cancelled_appointment.length / this.cancelled_paginate
          );
        }
      });
    },

    /* Convert Appointment Date */
    convertAppointmentDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2),
          year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
        return [day, mnth, year].join("-");
      }
    },
    /* Convert Date */
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2),
          year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
        return [day, mnth, year].join("-");
      }
    },
    /* Get time */
    convertTime(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          time =
            ("00" + date.getHours()).slice(-2) +
            ":" +
            ("00" + date.getMinutes()).slice(-2) +
            ":" +
            ("00" + date.getSeconds()).slice(-2);
        var H = +time.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = H < 12 ? " AM" : " PM";
        var timeString = h + time.substr(2, 3) + ampm;
        return timeString;
      }
    },

    reschedule(item) {
      this.patient_name = item.patient_name;
      this.reschedule_appointment.patient = item.patient;
      this.reschedule_appointment.hospital = item.hospital;
      this.reschedule_appointment.appointment_type = item.appointment_type;
      this.reschedule_appointment.appointment_id = item.name;
      this.reschedule_appointment.service_unit = item.service_unit;
      this.reschedule_appointment.appointment_date = this.selected_date;
      this.reschedule_appointment.appointment_time = this.selected_slot;
      this.reschedule_appointment.slot_no = this.selected_slot;
    },

    Reschedule_appointments() {
      if (!this.disabled) {
        const fromTime = this.selected_slot ? this.selected_slot.from_time : '';
        const slotNum = this.selected_slot ? this.selected_slot.slot_no : '';
        let data = {
          reschedule_appointment: this.reschedule_appointment
            .reschedule_appointment,
          patient: this.reschedule_appointment.patient,
          hospital: this.reschedule_appointment.hospital,
          appointment_type: this.reschedule_appointment.appointment_type,
          practitioner: this.doctor_name,
          service_unit: this.reschedule_appointment.service_unit,
          appointment_id: this.reschedule_appointment.appointment_id,
          appointment_date: this.selected_date,
          appointment_time: fromTime,
          slot_no: slotNum
        };
        CommonApi.post_data(
          "sahaj.finalapi.reschedule_appointment",
          JSON.stringify(data)
        ).then((res) => {
          this.showspinner = false;
          if (res.status_code == 500) {
            const dateParts = this.selected_date.split('-');
            const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: `You already have an Open appointment with this Doctor on this date - ${formattedDate}`,
              showConfirmButton: true,
            });
          } else {
            const formattedTime = moment(this.selected_slot.from_time, 'HH:mm').format('hh:mm A');
            this.$swal.fire({
              icon: "success",
              title: "Appointment Booked Successfully!",
              text:
                "Appointment Booked with " +
                this.patient_name +
                " on " +
                this.get_moment(this.selected_object).format("D MMMM YYYY") +
                " " +
                formattedTime,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
          }
        });
      }
    },

    /* Cancel Appointment */
    cancel_appointments(id, patientName) {
      this.$swal
        .fire({
          title: "Cancel Appointment",
          text: `Are you sure you want to cancel the appointment with ${patientName}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonColor: "#d33",
        })
        .then((result) => {
          if (result.value) {
            this.$swal({
              text: "Canceling your appointment...",
              showConfirmButton: false,
              allowOutsideClick: false,
              didOpen: () => {
                this.$swal.showLoading();
              },
            });
            let data = {
              appointment_id: id,
            };
            CommonApi.post_data("sahaj.finalapi.cancel_appointment", data).then(
              (res) => {
                if (res) {
                  this.$swal.fire({
                    icon: "success",
                    title: "Success",
                    text: res.message,
                    showConfirmButton: true,
                  }).then(() => {
                    window.location.reload();
                    this.get_patient_appointment_list_all();
                  });
                } else {
                  this.$swal.fire({
                    icon: "warning",
                    title: "Warning",
                    text: res.message,
                    showConfirmButton: true,
                  });
                }
              }
            );
          }
        });
    },
    viewappointmentdata(id, value) {
      this.download = value;
      this.get_appointment_popup_details(id, value);
    },

    /* Get Specific Appointment Data */
    get_appointment_popup_details(id, value) {
      var bodyFormData = new FormData();
      bodyFormData.append("name", id);
      CommonApi.post_data(
        "sahaj.api.get_appointment_popup_details",
        bodyFormData
      ).then((res) => {
        if (res.status_code == 200) {
          this.appointments_details.name = res.data[0].name;
          this.appointments_details.hospital = res.data[0].hospital;
          this.appointments_details.patient_name = res.data[0].patient_name;
          this.appointments_details.mobile = res.data[0].mobile;
          this.appointments_details.appointment_date =
            res.data[0].appointment_date;
          // this.appointments_details.appointment_time =
          //   res.data[0].appointment_time;
          const appointmentTime = new Date(`2000-01-01T${res.data[0].appointment_time}`);
          const formattedTime = appointmentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          this.appointments_details.appointment_time = formattedTime;
          this.appointments_details.image = res.data[0].image;
          if (value) {
            this.fake_appointments_details = res.data[0];
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.appointment-modal {
  display: block;
  text-align: center;
}

.appointment-modal-no-border {
  border: none !important;
}

/* .active {
  background-color: #66CDAA !important;
  color: #fff !important;
} */

.active {
  background-color: #66CDAA !important;
  border: 1px solid #66CDAA !important;
  color: #fff !important;
}

.slot_number {
  background-color: #4682B4;
  color: #fff;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 100%;
}

.rounded-brackets {
  font-size: 14px;
  /* Adjust the font size as needed */
  display: inline-flex;
  /* Use flex display to center the content */
  align-items: center;
  /* Center content vertically within the bracket */
  border: 1px solid #F8F8F8;
  /* Border style for the brackets */
  border-radius: 50%;
  /* Creates a fully round shape */
  padding: 5px 10px;
  /* Adjust padding as needed */
  margin: 0 5px;
  /* Adjust margin as needed to control spacing */
}

table {
  border-collapse: collapse;
  width: 100%;
  border-top: 1px solid #dddddd;
  /* Add an upper border */
}

th,
td {
  border: 1px solid #dddddd;
  /* You can adjust the border width and color as needed */
  padding: 8px;
  text-align: left;
}

th {
  background-color: #F8F8F8;
}

.reshedule_active_item {
  color: #66CDAA;
}

.submit-btn:hover {
  background-color: #008080;
}

.submit-btn:active {
  background-color: #008080;
}

.green-text {
    color: #66CDAA;
  }
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/hospital/Appointment.vue